import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../saga/rootsaga';

// Legacy reducers (existing functionality)
import CreateUserDetailsReducer from '../reducers/createUserReducer';
import getCustomersDataReducer from '../reducers/getCustomerDataReducer';
import disableCustomerReducer from '../reducers/disableCustomerReducer';
import createDatabaseReducer from '../reducers/createDatabaseReducer';
import getCustomerInfoReducer from '../reducers/getCustomerInfoReducer';
import updateCustomerReducer from '../reducers/updateCustomerReducer';
import createConfigReducer from '../reducers/createConfigReducer';
import getConfigReducer from '../reducers/getConfigReducer';
import updateConfigReducer from '../reducers/updateConfigReducer';
import maintenanceSchedulesReducer from '../reducers/maintenanceScheduleReducer';
import getHealthStatusReducer from '../reducers/getHealthStatusReducer';

// New RTK slices (Control Plane)
import tenantReducer from './slices/tenantSlice';
import dashboardReducer from './slices/dashboardSlice';
import authReducer from './slices/authSlice';
import costExplorerReducer from './slices/costExplorerSlice';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    // New Control Plane slices
    tenants: tenantReducer,
    dashboard: dashboardReducer,
    auth: authReducer,
    costExplorer: costExplorerReducer,

    // Legacy reducers (keep existing pages working)
    CreateUserDetailsReducer,
    getCustomersDataReducer,
    disableCustomerReducer,
    createDatabaseReducer,
    getCustomerInfoReducer,
    updateCustomerReducer,
    createConfigReducer,
    getConfigReducer,
    updateConfigReducer,
    maintenanceSchedulesReducer,
    getHealthStatusReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: true,
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);
